"use client";

import MapWrapper from "@/components/ui/MapWrapper";
import { usePreviewMode } from "@/components/ui/PreviewMode";

/** Sagskort's map of the case; in the CMS's preview, the illustration that stands in for it. */
export default function CaseMap({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) {
  const preview = usePreviewMode();
  return preview ? (
    preview.map
  ) : (
    <MapWrapper markers={[{ latitude, longitude }]} />
  );
}
